(ns journal-app-client.components.image
  (:require [journal-app-client.utils.react :as react]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [tick.core :as t]))

(defonce background-image-selection (r/atom nil))

(defn month->image-index []
  (let [date (t/new-date)
        month (t/int (t/month date))]
    (or @background-image-selection
      (case month
        (1 2 3) 1
        (4 5 6) 2
        (7 8 9) 3
        (10 11 12) 4
        1))))

(defn background-hsl []
  (let [image-index (month->image-index)]
    (case image-index
      1 [240 45 2]
      2 [212 48 5]
      3 [210 33 2]
      4 [235 60 4])))

(defn background-image [& [props]]
  (let [window-scroll @(rf/subscribe [:window-scroll])
        window-height @(rf/subscribe [:window-size :height])
        scroll-y (:scroll-y window-scroll)
        [initial-scroll-height set-initial-scroll-height] (react/use-state (or (.-scrollHeight (.-body js/document)) window-height))
        scroll-height (or (:scroll-height window-scroll) initial-scroll-height)
        scroll-percentage (/ scroll-y scroll-height)
        image-index (month->image-index)
        image-height-max-move (str "calc(-" scroll-height "px * 0.3)")
        transform (str "translate(-50%, calc(max(calc("image-height-max-move"), -" scroll-y "px) * " scroll-percentage "))")]
    (react/use-effect
      (fn [] (set-initial-scroll-height (.-scrollHeight (.-body js/document)))
        (fn []))
      #js [true])
    [:picture
     [:source {:media "(max-width: 1920px)" :src-set (str "images/Prancheta" image-index "-1024w.webp") :type "image/webp"}]
     [:source {:media "(min-width: 1920px)" :src-set (str "images/Prancheta" image-index "-1920w.webp") :type "image/webp"}]

     [:source {:media "(max-width: 1920px)" :src-set (str "images/Prancheta" image-index "-1024w.png") :type "image/png"}]
     [:source {:media "(min-width: 1920px)" :src-set (str "images/Prancheta" image-index "-1920w.png") :type "image/png"}]
     [:img
      {:style         (merge
                        {:position            "fixed"
                         :max-width           "min(100%, 70rem)"
                         :top                 "clamp(-25rem, calc(-30vw + 15vh), 0px)"
                         :left                "50%"
                         :object-fit          "contain"
                         :z-index             "0"
                         :transform           transform
                         :transition          "transform 500ms linear, filter calc(var(--transition-duration) * 4) ease"
                         :user-drag           "none"
                         :user-select         "none"
                         :-moz-user-select    "none"
                         :-webkit-user-drag   "none"
                         :-webkit-user-select "none"
                         :-ms-user-select     "none"
                         :pointer-events      "none"
                         :-webkit-mask-image  "linear-gradient(90deg, transparent, black 10%, black 90%, transparent)"
                         :mask-image          "linear-gradient(90deg, transparent, black 10%, black 90%, transparent)"}
                        (:style props))
       :fetchpriority "high"}]]))